
export interface CardState<T> {
  data: T[];
  loading: boolean;
  noData: boolean;
}

export interface PerfTableColumn {
  label: string;
  field: string;
}

// Shared value columns used across all retention perf-table-card sections (offer type, product, campaign, customer stage)
export const retentionValueCols: PerfTableColumn[] = [
  { label: 'Requests', field: 'requests' },
  { label: 'Saves', field: 'saves' },
  { label: 'Save Rate', field: 'saveRate' },
];

export interface DestinationPanelColumn {
  label: string;
  field: string;
}

export interface ViewToggleOption {
  label: string;
  value: string;
  icon?: string;
}

export interface LegendItem {
  label: string;
  icon: string;
}

export interface StatRowItem {
  label: string;
  value: string;
  subtitle?: string;
}

export interface InfoCardData {
  title: string;
  hint?: string;
  value: string | null;
  percentage?: number | null;
  is_negative?: boolean;
  subtitle?: string;
  subtitleLoading?: boolean;
  icon?: string;
}

export interface DualCardData {
  leftLbl: string;
  leftVal: string;
  rightLbl: string;
  rightVal: string;
  subtitle: string;
  subtitleLoading?: boolean;
  percentage?: number | null;
  is_negative?: boolean;
  hint?: string;
}

export enum SummaryCellType {
  Single = "single",
  Dual = "dual",
}

export type SummaryCell =
  | { type: SummaryCellType.Single; card: InfoCardData }
  | { type: SummaryCellType.Dual; card: DualCardData };

export enum CardLoaderSize {
  Small = "sm",
  Large = "lg",
}

export interface ProductActivityRow {
  name: string;
  impressions: string;
  percentage: number | null;
  is_negative: boolean;
}

export interface PortalActionRow {
  action: string;
  count: string;
  pctActions: string;
  pctSessions: string;
  expanded?: boolean;
  children?: PortalActionRow[];
}

export interface ProductReturnPerfRow {
  name: string;
  requests: string;
  deflected: string;
  deflectionRate: string;
  value?: string;
}

export interface AiInsight {
  text: string;
  icon?: string;
  iconBg?: string;
}

export enum SplitBarTone {
  Positive = "positive",
  Negative = "negative",
}

export interface SplitBarSegment {
  label: string;
  value: string;
  percentage: number;
  tone: SplitBarTone;
}

export interface PreviewChip {
  icon: string;
  label: string;
  dash?: boolean;
}
